import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import Menu from "./Menu";

const DesktopMenu = styled.div`
  position: sticky;
  top: ${css.VERTICAL_BOX_MARGIN_LARGE};

  width: 230px;
  box-sizing: border-box;

  margin: 0;
  padding: 20px 15px;

  border-radius: ${css.BOX_RADIUS_PRIMARY};
  background: ${css.BLUE_BOX_GRADIENT};

  display: flex;
  flex-direction: column;
`;

export default ({ unreadMessages, adPlan }) => {
  return (
    <DesktopMenu>
      <Menu unreadMessages={unreadMessages} adPlan={adPlan} />
    </DesktopMenu>
  );
};
